// extracted by mini-css-extract-plugin
export default {"iconSchedule":"header-edit-styles_iconSchedule__PM2+v","titleSchedule":"header-edit-styles_titleSchedule__CGXR2","containerHeader":"header-edit-styles_containerHeader__TnzRp"};